import { defineStore } from "pinia";

export const useNotificationsStore = defineStore('notificationsStore', {
    state: () => ({
        notifications: []
    }),
    actions: {
        addNotifications(notification) {
            this.notifications.push(notification)
        }
    }
})